const Divider = ({ className = "" }) => {
  return (
    <div className={`w-full flex justify-center py-8 ${className}`}>
      <div className="flex items-center gap-4 w-full max-w-md">
        <div className="flex-1 h-px bg-brand-red/30"></div>
        <div className="w-3 h-3 rotate-45 border-2 border-brand-red"></div>
        <div className="flex-1 h-px bg-brand-red/30"></div>
      </div>
    </div>
  );
};

export default Divider;
